export type ResourceCalendarRecurringTranslation = {
  /** The occurrence of a series the user may not read (no RECURRING_RESERVATION_READ). */
  anonymous: string;
  customer: string;
  fullDay: string;
  kind: string;
  kindFilter: {
    ALL: string;
    label: string;
    OFFER: string;
    RECURRING: string;
  };
  legend: {
    conflict: string;
    recurring: string;
  };
  manager: string;
  status: {
    ACTIVE: string;
    CANCELLED: string;
    CONFLICT: string;
  };
};

export const resourceCalendarRecurringTranslation: ResourceCalendarRecurringTranslation = {
  anonymous: 'Zajęte – rezerwacja stała',
  customer: 'Klient',
  fullDay: 'Cały dzień',
  kind: 'Rezerwacja stała',
  kindFilter: {
    ALL: 'Wszystkie',
    label: 'Rodzaj zajętości',
    OFFER: 'Pod oferty',
    RECURRING: 'Stałe',
  },
  legend: {
    conflict: 'Rezerwacja stała w konflikcie',
    recurring: 'Rezerwacja stała',
  },
  manager: 'Zarządzający',
  status: {
    ACTIVE: 'Aktywne',
    CANCELLED: 'Odwołane',
    CONFLICT: 'Konflikt – do przełożenia',
  },
};
